export default __webpack_public_path__ + "static/saleEng-6ccf8522b8e0f851f0dfc2cbc29ef3e5.svg";